import { type AppState } from 'src/redux/app/app.store'

export const selectCampaigns = (state: AppState) => state.campaigns.campaigns
export const selectCampaignFilters = (state: AppState) => state.campaigns.filters
export const selectOgCampaigns = (state: AppState) => state.campaigns.ogCampaigns
export const selectSearchTerm = (state: AppState) => state.campaigns.searchValue
